import Component from './Component';
import ScriptLoader from '../services/ScriptLoader';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let YTPlayer;
 const $article = document.querySelector('.js-article');


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */


function toggleFullScreen (element) {
    if (!document.mozFullScreen && !document.webkitIsFullScreen) {
        if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else {
            element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else {
            document.webkitCancelFullScreen();
        }
    }
}

function closeFullScreen () {
    if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else {
        document.webkitCancelFullScreen();
    }
}



function pushArticle () {
    if (!$article.classList.contains('is-hero-open')) {
        $article.classList.add('has-transition');
        setTimeout(() => {
            $article.classList.add('is-hero-open');
        }, 250);
    } else {
        $article.classList.remove('is-hero-open');
        setTimeout(() => {
            $article.classList.remove('has-transition');
        }, 250);
    }
}



/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Video extends Component {

    decorator () {
        return {
            selector : '.js-main',
            name : 'Video',
        }
    }


    constructor(element) {
        super(element);

        // Loads the IFrame Player API code asynchronously
        const _scriptTag = document.createElement('script');
        const _firstScript = document.getElementsByTagName('script')[0];
        _scriptTag.src = 'https://www.youtube.com/iframe_api';
        _firstScript.parentNode.insertBefore(_scriptTag, _firstScript);

        this.cacheElement();

        this.addCustomID();

        setTimeout(() => {
            window.load = this.onIFrameAPIReady();
        }, 2000);
    }


    cacheElement () {
        this.$el = Array.from(document.querySelectorAll('.js-video'));
    }


    addCustomID () {
        this.$el.forEach((item, idx) => {
            let idName = item.getAttribute('data-video-provider');
            const $container = item.querySelector('.js-video-container');
            $container.setAttribute('id', `vid-${idName}-${idx}`);
        })
    }


    onIFrameAPIReady () {
        this.$el.forEach((item,idx) => {
            const _obj = {
                selector: item,
                videoContainer: item.querySelector('.js-video-container'),
                selectorId: item.querySelector('.js-video-container').getAttribute('id'),
                videoId: item.getAttribute('data-video-id'),
                videoProvider: item.getAttribute('data-video-provider'),
                coverImage: item.querySelector('.js-video-cover'),
                videoBtn: item.querySelector('.js-video-btn')
            };

            if (_obj.videoProvider == 'youtube') {
                this._YTPlayer(_obj);
            } else if (_obj.videoProvider == 'vimeo') {
                this._VimeoPlayer(_obj);
            }
        });
    }


    // YOUTUBE PLAYER
    _YTPlayer (_obj) {
        YTPlayer = new YT.Player(_obj.selectorId, {
            height: 'auto',
            width: 'auto',
            videoId: _obj.videoId,
            events: {
                onReady: this._YTOnReadyVideo,
                onStateChange: this._YTPlayerStateChange
            }
        });
    }


    // YOUTUBE EVENT:: ON READY
    _YTOnReadyVideo (event) {
        const evtTarget = event.target;
        const iframeElm = evtTarget.f;
        const parentElm = iframeElm.parentElement;
        const coverImage = parentElm.querySelector('.js-video-cover');
        const videoBtn = parentElm.querySelector('.js-video-btn');

        parentElm.classList.add('is-ready');

        coverImage.addEventListener('click', event => {

            parentElm.classList.add('show-video');

            if (parentElm.closest('.js-hero')) {
                pushArticle();

                if (App.breakpoints.tablet >= App.$window.width()) {
                    toggleFullScreen(iframeElm);
                }
            }

            setTimeout(() => {
                evtTarget.playVideo();
            }, 300);
        });
    }


    // YOUTUBE EVENT:: ON STATE CHANGE
    _YTPlayerStateChange (event) {
        if (event.data == YT.PlayerState.PAUSED) {
            setTimeout(() => {
                event.target.a.parentElement.classList.remove('show-video');

                if (event.target.a.parentElement.closest('.js-hero')) {
                    pushArticle();
                    closeFullScreen();
                }
            }, 300);
        }
    }


    // VIMEO PLAYER
    _VimeoPlayer (_obj) {

        let VimeoPlayer = new Vimeo.Player(_obj.selectorId, {
            height: 'auto',
            width: 'auto',
            id: _obj.videoId
        });

        const evtTarget = VimeoPlayer.element;
        const parentElm = evtTarget.parentElement;
        const coverImage = parentElm.querySelector('.js-video-cover');
        const videoBtn = parentElm.querySelector('.js-video-btn');

        VimeoPlayer.ready().then(() => {
            parentElm.classList.add('is-ready');
        })


        coverImage.addEventListener('click', event => {
            parentElm.classList.add('show-video');

            if (parentElm.closest('.js-hero')) {
                pushArticle();

                if (App.breakpoints.tablet >= App.$window.width()) {
                    toggleFullScreen(parentElm.querySelector('iframe'));
                }
            }

            setTimeout(() => {
                VimeoPlayer.play();
            }, 300);
        });


        VimeoPlayer.on('pause', () => {
            setTimeout(() => {
                parentElm.classList.remove('show-video');

                if (parentElm.closest('.js-hero')) {
                    pushArticle();
                }
            }, 300);

            closeFullScreen();
        });
    }


    static bindElement ( element, options ) {
        let constructor = this;
        return new Promise(function ( resolve, reject ) {
            if ( !window.Vimeo ) {
            return ScriptLoader.load('vimeo-api', function () {
                resolve(new constructor(element, options));
            });
        }
        resolve(new constructor(element, options));
    });
  }

}
